import { Component, OnInit, Injectable, signal, computed, inject, NgModule } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { animate, style, transition, trigger } from '@angular/animations';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FunctionsService } from '../../data/functions.service';
import { finalize } from 'rxjs';
import { data } from '../../pages/negociacao/competitor-price-banner/data';
import { MessageService } from 'primeng/api';


// Interface para os dados do produto
interface RatingDistribution {
  stars: number;
  count: number;
  percentage: number;
}

interface Product {
  ean: string;
  name: string;
  image: string;
  averageRating: number;
  totalReviews: number;
  distribution: RatingDistribution[];
}


const INITIAL_PRODUCT_DATA: Product = {
  ean: '',// Inicial vazio para testar o carregamento
  name: '',
  image: '',
  averageRating: 0,
  totalReviews: 0,
  distribution: []
};

@Injectable({ providedIn: 'root' })
export class ReviewService {
  constructor(
    private functionsService: FunctionsService,
    private messageService: MessageService,
  ) { }
  // Usando Signals do Angular 18 para reatividade granular
  private _visible = signal(false);
  private _product = signal<Product>({
    ean: '',
    averageRating: 0,
    name: '',
    image: '',
    totalReviews: 0,
    distribution: []
  }); // Estado do produto pode ser global também
  loading = signal(false);
  // Expor sinais como leitura
  visible = this._visible.asReadonly();
  product = this._product.asReadonly();

  openWithEan(ean: string) {
    this.loading.set(true);
    this.functionsService.produto(ean).pipe(
      finalize(() => this.loading.set(false))
    ).subscribe({
      next: (res) => {
        if (res.ok) {
          const productResponse = res.body.data;
          this._product.set({
            ean: productResponse?.ean,
            name: productResponse?.name || '',
            averageRating: productResponse?.averageRating || 0,
            image: productResponse?.image || '',
            totalReviews: productResponse?.totalReviews || 0,
            distribution: productResponse?.distribution || [],
          });
          this._visible.set(true);
        }
      },
      error: () => {
        // Sem isto o clique em "Avaliar produto" falhava em silêncio: o
        // produto pode ter saído do catálogo depois da compra, e o usuário
        // não tinha como saber por que nada abria.
        this._product.set(INITIAL_PRODUCT_DATA);
        this.messageService.add({
          severity: 'error',
          summary: 'Não foi possível abrir a avaliação',
          detail: 'Não encontramos este produto no catálogo. Tente novamente mais tarde.',
          life: 6000,
        });
      },
    })
  }

  open() {
    this._visible.set(true);
    console.log('open');
    console.log(this.visible)
  }

  close() {
    this._visible.set(false);
  }
}

@Component({
  selector: 'app-review-modal',
  animations: [
    trigger('dialogAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)' }),
        animate('150ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0, transform: 'scale(0.95)' }))
      ])
    ]),
    trigger('overlayAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('150ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({ opacity: 0 }))
      ])
    ]),
    trigger('toastAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
      ])
    ])
  ],
  templateUrl: './review-modal.component.html',
  styleUrl: './review-modal.component.css'
})
export class ReviewModalComponent {
  constructor(
    private functionsService: FunctionsService,
  ){}

  Math = Math;
  reviewService = inject(ReviewService);
  product = this.reviewService.product;

  userRating: number = 0;
  hoverRating: number = 0;
  reviewTitle: string = '';
  reviewText: string = '';
  uploadedImages: { file: File, url: any }[] = [];

  closeDialog() { this.reviewService.close(); }

  onFileSelect(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log(file)
      const reader = new FileReader();
      reader.onload = (e: any) => { this.uploadedImages.push({ file: file, url: e.target.result }); };
      reader.readAsDataURL(file);
      event.target.value = '';
    }
  }

  removeImage(index: number) { this.uploadedImages.splice(index, 1); }

  getRatingLabel(stars: number): string {
    const labels = ['Péssimo', 'Ruim', 'Razoável', 'Muito Bom', 'Excelente'];
    return labels[stars - 1] || '';
  }

  isValid(): boolean {
    return this.userRating > 0 && this.reviewTitle.trim().length > 3 && this.reviewText.trim().length > 10;
  }

  submitReview() {
    const request = { ean: this.product().ean, rating: this.userRating, title: this.reviewTitle, text: this.reviewText, medias: this.uploadedImages }
    console.log('Enviado:', );
    this.functionsService.addProductReview(request).pipe(
      finalize(()=>{

      })
    ).subscribe({
      next: (res)=>{
        if(res.ok){
          alert('Avaliação adicionada com sucesso!')
          this.reviewService.close();
          this.userRating = 0; this.reviewTitle = ''; this.reviewText = ''; this.uploadedImages = [];
        }
      },
      error: () => {

      }
    });
  }
}
